import CurrencyExchangePageController from './currency-exchange-page-controller';

export default angular
    .module('paysera.currencyExchange.controllers', [])
    .controller('currencyExchangePageController', CurrencyExchangePageController)
    .name
;
